import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { ShopsCustomMapPageConfig } from '@front-platform/content-builder';
import { shopsCustomMapPageResolveConfig } from '@front-platform/content-builder';
import { Component, OnDestroy, OnInit, input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NavigationHistoryService } from '@core/services/navigation-history/navigation-history.service';
import { Meta } from '@angular/platform-browser';
export interface ShopsCustomMapPageRuntimeConfig {
  'body'?: any;
}

export type ShopsCustomMapPageConfigInput = Partial<
  Omit<ShopsCustomMapPageConfig, keyof ShopsCustomMapPageRuntimeConfig> &
    ShopsCustomMapPageRuntimeConfig
>;
export type ShopsCustomMapPageResolvedConfig = Omit<
  ShopsCustomMapPageConfig,
  keyof ShopsCustomMapPageRuntimeConfig
> &
  Partial<ShopsCustomMapPageRuntimeConfig>;
export interface ShopsCustomMapPageContract extends ConfigComponentContract<
  ShopsCustomMapPageConfigInput,
  ShopsCustomMapPageResolvedConfig
> {}

@Component({
  selector: 'app-shops-custom-map-page',
  templateUrl: './shops-custom-map-page.component.html',
  standalone: false,
})
export class ShopsCustomMapPageComponent implements OnInit, OnDestroy, ShopsCustomMapPageContract {
  readonly config = input<ShopsCustomMapPageConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    ShopsCustomMapPageConfig,
    ShopsCustomMapPageRuntimeConfig
  >(shopsCustomMapPageResolveConfig, () => ({ config: this.config() }));
  get body(): any {
    return this.resolvedConfig()['body'] as unknown as any;
  }
  get metaDescription(): string | undefined {
    return this.resolvedConfig()['meta_description'] as unknown as string | undefined;
  }

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly navigationHistoryService: NavigationHistoryService,
    private readonly meta: Meta,
  ) {}

  ngOnInit(): void {
    this.navigationHistoryService.pushStateFromActivatedRouteSnapshot(
      'map',
      this.activatedRoute.snapshot,
    );
    const bodyElement = document.body;
    bodyElement.classList.add('block-vertical-scroll');

    if (this.metaDescription) {
      this.meta.updateTag({
        name: 'description',
        content: this.metaDescription,
      });
    }
  }

  ngOnDestroy(): void {
    const bodyElement = document.body;
    bodyElement.classList.remove('block-vertical-scroll');
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(ShopsCustomMapPageComponent, { 'keyAliases': {} });
